import BooleanFilter from "./BooleanFilter";
import MultipleChoiceFilter from "./MultipleChoiceFilter";
import OrganisationFilter from "./OrganisationFilter";
import SortingConfiguration from "./SortingConfiguration";
import StringFilter from "./StringFilter";

const FILTERABLE_QUESTION_TYPES = ['checkbox', 'multiple_choice', 'multiple_select', 'text'];
const FILTERABLE_SOURCES = ['column', 'organisation', 'search', 'goal', 'subscription', 'resubscription'];

export function isFieldFilterable(field, questions) {
    if (!field) return false;
    if (FILTERABLE_SOURCES.includes(field.source)) return true;
    if (['survey_response', 'answerable_question'].includes(field.source)) {
        const question = questions?.find(q => q.id === field.questionId);
        return FILTERABLE_QUESTION_TYPES.includes(question?.questionType);
    }
    return false;
}

export default function FilterConfiguration({filterKey, closeConfiguration, hideSorting = false}) {
    const dashboardField = useSel(s => s.dashboard.dashboardFields.find(f => 'field_' + f.id === filterKey) ?? null);
    const questions = useSel(s => s.dashboard.survey.questions);

    const filter = useSel(s => s.local.filters ? s.local.filters[filterKey] : null);

    const FilterConfigure = () => {
        if (!dashboardField) return null;

        switch (dashboardField?.source) {
            case 'column': return <StringFilter filterKey={filterKey} closeConfiguration={closeConfiguration} />
            case 'organisation': return <OrganisationFilter filterKey={filterKey} closeConfiguration={closeConfiguration} />
            case 'search': 
            case 'goal':
            case 'subscription':
            case 'resubscription':
                return <BooleanFilter filterKey={filterKey} closeConfiguration={closeConfiguration} />
            case 'survey_response':
            case 'answerable_question':
                const question = questions ? questions.find(q => q.id === dashboardField.questionId) : null;
                switch (question?.questionType) {
                    case 'checkbox': return <BooleanFilter filterKey={filterKey} closeConfiguration={closeConfiguration} />
                    case 'multiple_choice':
                    case 'multiple_select':
                        return <MultipleChoiceFilter filterKey={filterKey} closeConfiguration={closeConfiguration} />
                    case 'text': return <StringFilter filterKey={filterKey} closeConfiguration={closeConfiguration} />
                    default: return <div>Unsupported survey question type ({question?.questionType})</div>
                }
            default: return <div>Unsupported filter source ({dashboardField?.source})</div>
        }
    }
    
    const SortingConfigure = () => {
        if (!dashboardField?.id) return null;
        return <SortingConfiguration fieldId={dashboardField?.id} closeConfiguration={closeConfiguration} />
    }

    return <div className="filter-configuration">
        {!hideSorting && <SortingConfigure />}
        <FilterConfigure />
    </div>

}